import styled from 'styled-components'
import { Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import AbsentUserAvatar from './AbsentUserAvatar'
import AbsencesPopover from './AbsencesPopover'

type AbsentWidgetProps = {
  users: any[]
}

const AbsentWidget = ({ users }: AbsentWidgetProps) => {
  const { t } = useTranslation()

  if (!users) return null

  const displayedUsers = users.slice(0, 9)
  const additionalUsers = users.slice(9)

  return (
    <Wrapper>
      <Heading level={3}>{t('ABSENT')}</Heading>
      <StyledDivider />
      {users.length === 0 ? (
        <NoContent>
          <Heading level={1}>{t('NONE')}</Heading>
          <LightText weight="medium">
            {t('TEAM_MEMBERS').toLowerCase()}
          </LightText>
        </NoContent>
      ) : (
        <Container>
          {displayedUsers.map((user) => (
            <AbsentUserAvatar user={user} />
          ))}
          {additionalUsers.length > 0 && (
            <AbsencesPopover users={additionalUsers}>
              <LightHeading
                level={3}
              >{`+${additionalUsers.length}`}</LightHeading>
            </AbsencesPopover>
          )}
        </Container>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${(props) => props.theme.color.neutral.color11};
  padding: 24px;
  border-radius: ${(props) => props.theme.properties.borderRadius.large};
  width: 260px;
  flex: 1;
`
const StyledDivider = styled(Divider)`
  margin: 0;
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`
const LightHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color4};

  &:hover {
    cursor: default;
  }
`
const NoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin: auto 0;
`
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export default AbsentWidget
